// third-party
import {combineReducers} from "redux";

// project imports
import configReducer from "./slices/config";
import userReducer from "./slices/user";
import gameReducer from "./slices/game";
import settingReducer from "./slices/setting";
import messageReducer from "./slices/message";
import homeReducer from "./slices/home";
import chatReducer from './slices/chat';

import {persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";

// ==============================|| COMBINE REDUCER ||============================== //
const settingPersistConfig = {
    key: "setting",
    storage,
    keyPrefix: "playing-",
    whitelist: ["hideZeroBalance", "isFiat"],
};

const reducer = combineReducers({
    config: persistReducer(
        {
            key: "config",
            storage,
            keyPrefix: "playing-",
        },
        configReducer,
    ),
    game: gameReducer,
    user: persistReducer(
        {
            key: "user",
            storage,
            keyPrefix: "playing-",
        },
        userReducer,
    ),
    setting: persistReducer(settingPersistConfig, settingReducer),
    message: messageReducer,
    home: homeReducer,
    chat: chatReducer,
});

export default reducer;